import type { components } from "../generated/openapi";

export type ApiErrorCode = components["schemas"]["ApiErrorCode"];
export type ApiErrorBody = components["schemas"]["ApiErrorBody"];

// Все коды из контракта. `Record` не даст забыть код, который добавил бэкенд:
// `pnpm typecheck` упадёт, пока его нет в этом списке.
const KNOWN_CODES: Record<ApiErrorCode, true> = {
  not_authenticated: true,
  forbidden: true,
  not_found: true,
  validation_error: true,
  throttled: true,
  match_not_found: true,
  analysis_limit_reached: true,
  match_not_ready: true,
  confirmation_required: true,
  game_mode_not_supported: true,
  billing_disabled: true,
  autopay_already_active: true,
  autopay_not_found: true,
  clip_limit_reached: true,
  clips_unavailable: true,
};

export const isApiErrorCode = (value: unknown): value is ApiErrorCode =>
  typeof value === "string" && Object.hasOwn(KNOWN_CODES, value);
